module.exports = __webpack_public_path__ + "img/docx.2da11a81.png";